<template>
    <component :is="view" v-on:abbort="$emit('abbort')" v-on:stepdone="$emit('stepdone')"> </component>
</template>

<script>

    import Finished from '../views/Finshed_Default'
    import FinishedReturn from '../views/Finished_Returnlabel'

    export default {
        name: "forthstep",

        components: {
            Finished,
            FinishedReturn
        },

        computed: {

            view () {

                let reason  = this.$store.getters.getReason

                switch( true ){

                    case (reason === 'defect'):
                        return 'finished'

                    case (reason === 'revocation' ):
                        return 'finished-return'

                    default:
                        return 'finished'
                }
            }
        }
    }
</script>

<style scoped>

</style>